module.exports = __webpack_public_path__ + "static/media/37.7a8a402c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/37.svg
// module id = 147
// module chunks = 0